<template>
  <div :class="$vuetify.breakpoint.width < 550 ? 'maklerservice-page-container-xs' : 'maklerservice-page-container'">

    <v-container class="maklerservice-page pa-0" fluid>

      <v-row :column="$vuetify.breakpoint.width < 1260"
                :class="{'flex-nowrap big-screen': $vuetify.breakpoint.width > 1259 }"
                no-gutters>

        <v-col :class="{'col-12': $vuetify.breakpoint.width > 1259 }"
               class="makler-team-container">
          <makler-team-block :team-info="teamList" />
        </v-col>

        <div :class="{'pl-56': $vuetify.breakpoint.width > 1259, 'mx-auto': $vuetify.breakpoint.width <= 1259,}"
             class="contacts-box-container">
          <makler-contact-box :boxes="contactpoints"
                              :sticky="useSticky()" />
        </div>

      </v-row>

      <v-divider class="maklerpage-divider bg-dimmeddark" />

      <v-row no-gutters>

        <div class="makler-regional-container">
          <makler-team-block :team-info="regionMaklers" />
        </div>
      </v-row>

    </v-container>

  </div>
</template>

<script>
import MaklerTeamBlock from '@/components/vertriebsunterstuetzung/MaklerTeamBlock';
import MaklerContactBox from '@/components/vertriebsunterstuetzung/MaklerContactBox';
import BrowserDetectionMixin from "@/components/helper/BrowserDetectionMixin";

export default {
  name: "MaklerservicePage",
  components: { MaklerTeamBlock, MaklerContactBox },
  mixins: [BrowserDetectionMixin],
  computed: {
    teamList: function () {
      return this.$store.state.staticPagesContent.VertriebMaklerservice.service;
    },
    regionMaklers: function () {
      return this.$store.state.staticPagesContent.VertriebMaklerservice.vorOrt;
    },
    contactpoints: function () {
      return this.$store.state.staticPagesContent.VertriebMaklerServiceSidebar;
    }
  },
  methods: {
    useSticky() {
      return !this.isEdge() && (this.$vuetify.breakpoint.width > 1259);
    }
  }
};
</script>

<style>
.maklerservice-page-container-xs {
  margin: 0 16px 100px 16px;
  display: flex;
  justify-content: center;
}

.maklerservice-page-container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}

.maklerservice-page {
  width: 100%;
  position: relative;
}

.maklerservice-page > .row {
  display: flex;
  justify-content: space-between;
}

.maklerservice-page .big-screen .makler-team-container {
  max-width: 816px;
}

.maklerservice-page .makler-team-container {
  flex: 1 1 auto;
}

.maklerservice-page .pl-56 {
  padding: 0 0 0 56px;
}

.maklerservice-page .makler-regional-container {
  max-width: calc(100% - 4px);
  flex: 1 1 auto;
}

.maklerservice-page .maklerpage-divider {
  margin-top: 80px;
}

.maklerservice-page .bg-dimmeddark {
  background-color: #979797;
}

.maklerservice-page .landkarte {
  max-width: calc(100% - 458px);
  max-height: 544px;
  margin-top: 132px;
}

@media screen and (max-width: 1000px) {
  .maklerservice-page .hide {
    display: none !important;
  }
}
</style>
